import React from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { useFeatures } from '@atc/features';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

function PsxCtaContainer({ className, layout, minHeight, isDirector }) {
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory) || {};
    const {
        brand: [, { consumer_brand: consumerBrand }],
    } = useFeatures([
        'brand',
    ]);

    const { id = '', vin = '', title = '', listingTitlePSX = '', year = '', make: { name: makeName = '' } = {},
        model: { name: modelName = '' } = {}, trim = {}, consumerId = '', owner = {}, pricingDetail = {}, financingTypePSX = '' } = listing;

    // only lsc data needed by the components
    const data = {
        id,
        vin,
        title,
        listingTitlePSX,
        year,
        make: makeName,
        model: modelName,
        trim,
        consumerId,
        owner,
        pricingDetail,
        financingTypePSX,
    };
    return (
        <div
            className={className}
            style={{ minHeight }}
        >
            <lead-generation
                listing-id={listing.id}
                listing-data={JSON.stringify(data)}
                brand={consumerBrand}
                layout={layout}
                is-director={isDirector}
            />
        </div>
    );
}
PsxCtaContainer.propTypes = {
    className: PropTypes.string,
    minHeight: PropTypes.string,
    isDirector: PropTypes.bool,
    layout: PropTypes.oneOf(['sellerPanel', 'sticky', 'makeOffer', 'mediaGallery', 'startPurchase', 'uiLess']),
};
export default React.memo(PsxCtaContainer);
